import { defineMessages } from "react-intl";

const messages = defineMessages({
  showApprovedLabel: {
    id: "Appointment.AppointmentAIReportsTableTopBar.showApprovedLabel",
    defaultMessage: "Show approved",
  },
  findNameLabel: {
    id: "Appointment.AppointmentAIReportsTableTopBar.findNameLabel",
    defaultMessage: "Find name",
  },
});

export default messages;
